<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#alte2">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Alte substanțe</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black" v-if="active"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black" v-if="active"></span></div>
    </div>

    <div id="alte2" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fibre:</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue"></span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue"></span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">- GOS/FOS**</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.2</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grași polinesaturați:</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue"></span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue"></span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">- Acid docosahexaenoic (DHA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.014</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">- Acid eicosapentaenoic (EPA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.009</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">- Acid linoleic (LA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.594</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">- Acid alfa-linolenic (ALA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.119</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">*VNR/100 ml. VNR: valoarea nutrițională de referință</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue"></span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue"></span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">**Galacto-oligozaharide și Fructo-oligozaharide</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue"></span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alte",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
